import { connexeCtrlImgSearch, iws_ConnexePropertyImgClick, iws_IsiSuggestUpdateShownValue, searchAvailableScreenList, suggConnexeSearchAvailability } from "./Isilog/Core/IsiSuggest";
import { XmlUtilities } from "./XmlUtilities";

/**
 * Fonction qui v�rifie cot� client que la navigation est autoris� (notamment que le windos.name est renseign� sur une page ayant d�j� un id de session ou venant une redirection server.)
 */
export function checkDuplicateTab() {


    if (window.name === "") {
        // si on a un IwsId

        if (window.location.search.indexOf("?IwsId=") >= 0 || window.location.search.indexOf("&IwsId=") > 0) {
            //Si on vient d'une redirection g�r�e par le serveur
            //var isRedirectionFormServer = document.getElementById("ihdIsRedirectionFromServer");
            var isRedirectionFormServer = jQuery('meta[name=RedirectionFromServer]');
            if (isRedirectionFormServer && isRedirectionFormServer.attr("content") == "true") {
                // On laisse passer car le serveur � raison mais on identifie la tab
                // pour les prochaines navigations clientes.
                window.name = Date.now().toString();
                isRedirectionFormServer.attr("content", "");

            } else {
                //Si on est dans une frame on laisse passer.
                if (top != window) {
                    window.name = Date.now().toString();
                } else {
                    //On est vient d'une duplication d'onglet ou d'une navigation douteuse...
                    var applicationName = window.location.pathname.substr(1);
                    //dans le cadre d'une installation que n'a pas d'application alors on retire l'eventuel Pages.
                    applicationName = applicationName.substr(0, applicationName.indexOf("/")).replace("Pages", "");
                    window.location.href = "/" + applicationName;
                }


            }

        } else {
            //On set le nom de la page car l'appli va g�n�rer une nouvelle session cot� serveur
            if (window.name === "") {
                window.name = Date.now().toString();
            }

        }

    }
}
window.checkDuplicateTab = checkDuplicateTab;

/************************************************************************
' Script		: basic.js
' Auteur        : ABIG
' Date creation : 11/12/2003
' Modificateur  : ABIG
' Date modif.   : 11/12/2003
' Description   : Gestion des controles
' Commentaires	: 
'***********************************************************************/

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 29/10/2003
'- Description : Verifie si une valeur est nulle ou vide 
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 29/10/2003
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'-   -> oValue : Valeur a verifier
'-----------------------------------------------------------------------------------------*/
export function IsIdEmpty(oValue) {
    return (!oValue || oValue === "");
}
window.IsIdEmpty = IsIdEmpty;

function _redirectJs(doc, url) {
    ///<summary>redirige vers la page demand� en indiquant qu'il s'agit d'une redirection Isilog</summary>
    window.iwsNavigation = true;
    jQuery(doc.location).attr('href', url);
}

export function IsiRedirectJs(url) {
    ///<summary>redirige vers la page demand� en indiquant qu'il s'agit d'une redirection Isilog</summary>
    _redirectJs(document, url);
}
window.IsiRedirectJs = IsiRedirectJs;
export function RedirectParentJs(url) {
    ///<summary>redirige vers la page demand� en indiquant qu'il s'agit d'une redirection Isilog</summary>
    _redirectJs(window.parent.document, url);
}
window.RedirectParentJs = RedirectParentJs;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ORIC
'- Date        : 04/11/2005
'- Description : Caracteres a echapper lorsque des donnees sont envoyees en POST.
'-				 Aucun autre traitement est a faire sur ces donnees.
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> s : Valeur a convertir
'-----------------------------------------------------------------------------------------*/
export function iws_PostEscape(s) {
    var re;

    //ARAN 20/12/2018 [Dysf.85878]Il faut remplacer le caract�re % sinon �a fait nawak
    re = /%/gi;
    s = s.replace(re, "%25");
    re = /&/gi;
    s = s.replace(re, "%26");
    re = /\+/gi;
    s = s.replace(re, "%2B");
    re = /\?/gi;
    s = s.replace(re, "%3F");
    re = /\=/gi;
    s = s.replace(re, "%3D");
    return s;
}
window.iws_PostEscape = iws_PostEscape;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ORIC
'- Date        : 12/04/2006
'- Description : Encodage de caracteres speciaux en HTML. Le decodage devraient se faire 
'-				 automatiquement par le navigateur ^_^
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : CEGO
'- Date        : 13/01/2009
'- Description : [DYSFCT:32606] : Le code HTML du caractere < est 62 et non 60.
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> s : Valeur a convertir
'-----------------------------------------------------------------------------------------
'- Dysf 17390 le ';' est necessaire*/
export function iws_HTMLEncode(s) {
    var re;

    re = /</gi;
    s = s.replace(re, "&#60;");
    re = />/gi;
    s = s.replace(re, "&#62;");
    re = /\+/gi;
    s = s.replace(re, "&#43;");
    return s;
}
window.iws_HTMLEncode = iws_HTMLEncode;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description : Convertit une valeur en chaine de caractere encodee
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> s : Valeur a convertir
'-----------------------------------------------------------------------------------------*/
export function escapeCarac(s) {
    var re;
    //s = escape(new String(s))
    re = /"/gi;
    s = s.replace(re, "%22");
    re = /#/gi;
    s = s.replace(re, "%23");
    re = /'/gi;
    s = s.replace(re, "%27");
    re = /;/gi;
    s = s.replace(re, "%3B");
    re = /&/gi;
    s = s.replace(re, "%26");
    re = /\+/gi;
    s = s.replace(re, "%2B");
    re = / /gi;
    s = s.replace(re, "%20");
    return s;
}
window.escapeCarac = escapeCarac;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description : Convertit une valeur encodee en chaine de caractere non codee
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> s : Valeur a convertir
'-----------------------------------------------------------------------------------------*/
export function i_unEscapeCarac(s) {
    s = unescape(s);
    return s;
}
window.i_unEscapeCarac = i_unEscapeCarac;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ORIC
'- Date        : 16/08/2006
'- Description : Convertit un entier decimal en hexadecimal.
'-----------------------------------------------------------------------------------------*/
export function iws_iToHex(x) {
    var iNum2: any = x % 16;
    var iNum1: any = (x - iNum2) / 16;

    for (var i = 0; i < 6; i++) {
        if (iNum1 == 10 + i) {
            iNum1 = String.fromCharCode(65 + i);
        }
        if (iNum2 == 10 + i) {
            iNum2 = String.fromCharCode(65 + i);
        }
    }

    return "" + iNum1 + iNum2;
}
window.iws_iToHex = iws_iToHex;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description : Convertit une valeur en boolean
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> oVal : Valeur a convertir
'-----------------------------------------------------------------------------------------*/
export function nullToBool(oVal) {
    if (oVal != null) {
        if (oVal) {
            if (oVal === true || oVal == "true") {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } else {
        return false;
    }
}
window.nullToBool = nullToBool;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description : Convertit une valeur en chaine de caractere
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description : 
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> oVal : Valeur a convertir
'-----------------------------------------------------------------------------------------*/
export function nullToString(oVal) {
    // CAS PARTICULIER
    //ATTENTION if oVal est un numerique = 0 alors ca retourne ""
    if (oVal) {
        if (oVal) {
            return oVal;
        } else {
            return "";
        }
    } else {
        return "";
    }
}
window.nullToString = nullToString;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description : Convertit une valeur en nombre entier
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> oVal : Valeur a convertir
'-----------------------------------------------------------------------------------------*/
export function nullToInt(oVal) {
    if (!isNaN(parseInt(oVal, 10))) {
        return parseInt(oVal, 10) + "";
    } else {
        return "";
    }
}
window.nullToInt = nullToInt;

/**
 * [DEV26377] - Cette fonction permet de definir le delta de valeur possible pour un champ numerique
 * @param nbDigit
 * @param nbDecimal
 * @returns
 */
export function iws_setDeltaFormatNum(nbDigit: number, nbDecimal: number): string {
    let cpt: number;
    let mask = "";
    let nbInt = 0;

    // On va recuperer le nombre de caracteres de la partie entiere
    if (nbDecimal && nbDecimal > 0) {
        nbInt = nbDigit - nbDecimal;
    } else {
        nbInt = nbDigit;
    }

    // on va les parcourir definir la partie entiere
    for (cpt = 0; cpt < nbInt; cpt++) {
        mask = mask + "9";
    }

    // Si on a des decimal on va rajouter la partie decimal
    if (nbDecimal && nbDecimal > 0) {
        mask = mask + ".";
        // on va les parcourir definir la partie entiere
        for (cpt = 0; cpt < nbDecimal; cpt++) {
            mask = mask + "9";
        }
    }
    return mask;
}
window.iws_setDeltaFormatNum = iws_setDeltaFormatNum;


/**
 * Retourne la valeur d'un �l�ment depuis son ID.
 * @param id
 * @returns
 */
export function getValueFromCtrlId(id): string {
    const ctrl = document.getElementById(id) as HTMLInputElement;
    let value: string;

    if (ctrl) {
        if (ctrl.value !== "") {
            value = ctrl.value;
        } else if (jQuery(ctrl).text() !== "") {
            value = jQuery(ctrl).text()
        } else {
            value = "";
        }
    }
    return value;
}
window.getValueFromCtrlId = getValueFromCtrlId;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 29/10/2003
'- Description : Verifie si une valeur est null ou vide 
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 29/10/2003
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'-   -> oValue : Valeur a verifier
'-----------------------------------------------------------------------------------------*/
export function isEmpty(v: any): boolean {
    return (v === null || v === "");
}
window.isEmpty = isEmpty;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description : Converti une valeur en nombre flottant
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 17/02/2004
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'   -> oVal : Valeur a convertir
'-----------------------------------------------------------------------------------------*/
export function NullToFloat(oVal) {
    if (oVal) {
        var s = oVal.toString();

        var re = /,/gi;
        s = s.replace(re, ".");

        var o = Number(s);

        // si la valeur est un nombre
        if (!isNaN(o)) {
            return o + "";
        } else {
            return "";
        }
    } else {
        return "";
    }
}
window.NullToFloat = NullToFloat;



/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : PBON
'- Date        : 04/02/2005
'- Description : Cette fonction transforme une chaine de caracteres representant un nombre
'-				 decimal "xx.yy" ou "xxx,yy" en un nombre reel.
'-- MODIFICATION -----------------------------------------------------------------------------
'- Auteur      : GBAU
'- Date        : 01/03/2011
'- Description : DYSF0000038269 On utilise parseFloat pour eviter les erreur d'arrondi JS
'-- MODIFICATION -----------------------------------------------------------------------------
'- Auteur      : JBUI
'- Date        : 17/07/2012
'- Description : DEV53610 Affichage des nombres avec un s�parateur de milliers
'----------------------------------------------------------------------------------------*/
export function isiGetNumber(sNombre) {
    if (sNombre != "") {
        return Number.parseLocale(sNombre.toString());
    } else {
        return sNombre;
    }
}
window.isiGetNumber = isiGetNumber;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 04/10/2004
'- Description : Indique si un objet est de type numerique
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      :
'- Date        :
'- Description :
'-- PARAMETRES ---------------------------------------------------------------------------
' ENTREE
'-   -> o : Objet a tester
'-----------------------------------------------------------------------------------------*/
export function isNumeric(o) {
    var n = parseInt(o, 10);
    return (!isNaN(n));
}
window.isNumeric = isNumeric;

/*-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
' DATE : 22/11/2004
' AUTEUR : ABUR
' DESCRIPTION : Retourne la chaine situee entre deux delimiteurs connus
'				(Traduction de retourneChaine en C/S)
'-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
' ENTREE-SORTIE :
'       -> sValeur : Chaine dans la laquelle on fait la recherche
'       -> sDelim1 : premier delimiteur
'       -> sDelim2 : deuxieme delimiteur
'-------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
' SORTIE :
' - Succes : retourne la chaine contenue entre les deux delimiteurs
' - Echec : retourne chaine vide
'-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------*/
export function retourneChaine(sValeur, sDelim1, sDelim2) {
    var sTmp;
    var iIndexDelim1;
    var sLgDelim1;
    var iIndexDelim2;

    if (sValeur !== "") {
        sTmp = sValeur;
        iIndexDelim1 = sValeur.indexOf(sDelim1);
        sLgDelim1 = sDelim1.length;
        iIndexDelim2 = sValeur.indexOf(sDelim2);
        if ((iIndexDelim1 + sLgDelim1) == iIndexDelim2) {
            sTmp = "";
        } else {
            sTmp = sTmp.substring(iIndexDelim1 + sLgDelim1, iIndexDelim2);
        }
        //sTmp = Right(sTmp, Len(sTmp) - InStr(1, sTmp, sDelim1) - Len(sDelim1) + 1);
        //sTmp = Left$(sTmp, InStr(1, sTmp, sDelim2) - 1);
    } else {
        sTmp = "";
    }
    return sTmp;
}
window.retourneChaine = retourneChaine;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 20/10/2003
'- Description : Poste la page au serveur
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 20/10/2003
'- Description :
'-----------------------------------------------------------------------------------------*/
export function submitFormulaire() {
    isiApp.uploadState();
    uiCore.flushClientState();
    isiApp.submit();
}
window.submitFormulaire = submitFormulaire;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 07/11/2003
'- Description : Permet de retourner des valeurs a une page appelante
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 05/11/2003
'- Description :
'-----------------------------------------------------------------------------------------
'- ENTREE :
'-  -> sRes : Liste des valeurs
'-----------------------------------------------------------------------------------------*/
export function ReturnValues(sRes) {
    var MyArgs = [sRes];
    window.returnValue = MyArgs;
}
window.ReturnValues = ReturnValues;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 31/03/2006
'- Description : Indique si on est en recherche
'-----------------------------------------------------------------------------------------*/
export function iws_isInSearchState() {
    /// <summary>
    /// Indique si l'on est en recherche.
    /// </summary>
    return (screenCore.getCursorState() == CURSOR_STATE_SEARCH);
}
window.iws_isInSearchState = iws_isInSearchState;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : CEGO
'- Date        : 30/06/2010
'- Description : Indique si on est en Duplication.
'-----------------------------------------------------------------------------------------*/
export function iws_isInDuplicationState() {
    /// <summary>
    /// Indique si l'on est en Duplication.
    /// </summary>
    return (screenCore.getCursorState() == CURSOR_STATE_DUPLICATE);
}
window.iws_isInDuplicationState = iws_isInDuplicationState;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ORIC
'- Date        : 11/05/2006
'- Description : Indique si on est en Ajout ou Duplication.
'-----------------------------------------------------------------------------------------*/
export function iws_isInAddOrDuplicationState() {
    /// <summary>
    /// Indique si l'on est en Ajout ou Duplication.
    /// </summary>
    var state = screenCore.getCursorState();
    return (state == CURSOR_STATE_DUPLICATE || state == CURSOR_STATE_ADD);
}
window.iws_isInAddOrDuplicationState = iws_isInAddOrDuplicationState;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ORIC
'- Date        : 11/05/2006
'- Description : Indique si on est en MAJ ou Consultation.
'-----------------------------------------------------------------------------------------*/
export function iws_isInUpdateOrConsultState() {
    /// <summary>
    /// Indique si l'on est en Consultation ou en modification.
    /// </summary>
    var state = screenCore.getCursorState();
    return (state == CURSOR_STATE_CONSULT || state == CURSOR_STATE_UPDATE);

}
window.iws_isInUpdateOrConsultState = iws_isInUpdateOrConsultState;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 25/03/2008
'-----------------------------------------------------------------------------------------*/
export function iws_isInConsultState() {
    /// <summary>
    /// Indique si l'on est en consultation.
    /// </summary>
    return (screenCore.getCursorState() == CURSOR_STATE_CONSULT);
}
window.iws_isInConsultState = iws_isInConsultState;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : CEGO
'- Date        : 19/11/2007
'- Description : Indique si l'on est en ajout, dupliquer ou modification.
'-----------------------------------------------------------------------------------------*/
export function iws_isInAddOrDuplicationOrUpdateState() {
    /// <summary>
    /// Indique si l'on est en Ajout ou Duplication ou modification.
    /// </summary>
    var state = screenCore.getCursorState();
    return (state == CURSOR_STATE_DUPLICATE
        || state == CURSOR_STATE_ADD
        || state == CURSOR_STATE_UPDATE);
}
window.iws_isInAddOrDuplicationOrUpdateState = iws_isInAddOrDuplicationOrUpdateState;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : RGEL
'- Date        : 02/02/2007
'- Description : Indique si on est en MAJ.
'-----------------------------------------------------------------------------------------*/
export function iws_isInUpdate() {
    /// <summary>
    /// Indique si l'on est en modification.
    /// </summary>

    return (screenCore.getCursorState() == CURSOR_STATE_UPDATE);
}
window.iws_isInUpdate = iws_isInUpdate;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : GBAU
'- Date        : 26/12/2012
'- Description : Indique si on est en Ajout.
'-----------------------------------------------------------------------------------------*/
export function iws_isInAddState() {
    /// <summary>
    /// Indique si l'on est en Ajout.
    /// </summary>
    return (screenCore.getCursorState() == CURSOR_STATE_ADD);
}
window.iws_isInAddState = iws_isInAddState;

// On ajoute ces classes l� d�finies en TS (XmlUtilities et HttpUtilities) car elles sont appel�es depuis le JS
window.xmlUtilities = XmlUtilities;
window.xmlUserSettings = XmlUtilities.buildXmlUserSettings();

/*
Fonction surcharg�e par les pages permettant d'initilis�e 
la page le chargement.
*/
//export function window_onload() {

//}
//window.window_onload = window_onload;

// On ajoute ces classes l� d�finies en TS (IsiSuggest) car elles sont appel�es depuis le JS
window.searchAvailableScreenList = searchAvailableScreenList
window.suggConnexeSearchAvailability = suggConnexeSearchAvailability
window.iws_ConnexePropertyImgClick = iws_ConnexePropertyImgClick
window.connexeCtrlImgSearch = connexeCtrlImgSearch
window.iws_IsiSuggestUpdateShownValue = iws_IsiSuggestUpdateShownValue
